import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/site/login/login.component';
import { HomeComponent } from './components/site/home/home.component';
import { OrdersComponent } from './components/site/orders/orders.component';
import { OrderDetailsComponent } from './components/site/order-details/order-details.component';
import { ThankYouComponent } from './components/site/thank-you/thank-you.component';
import { ResetPasswordComponent } from './components/site/reset-password/reset-password.component';
import { SignatureComponent } from './components/site/signature/signature.component';
import { AgreementComponent } from './components/site/agreement/agreement.component';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [

{ path: 'login', component: LoginComponent },
{path: 'reset-password/:token', component : ResetPasswordComponent},
{path: 'reset-password', component : ResetPasswordComponent, canActivate: [AuthGuard]},
{ path: '', component: HomeComponent, canActivate: [AuthGuard]},
{ path: 'orders', component : OrdersComponent, canActivate: [AuthGuard]},
{ path: 'order-edit/:id', component : HomeComponent, canActivate: [AuthGuard]},
{ path: 'order-details/:id', component : OrderDetailsComponent},
{ path: 'signature', component : SignatureComponent},
{ path: 'agreement', component : AgreementComponent},
{ path: 'thankyou', component : ThankYouComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
